/** Nav labels keyed by id — never use the English title as identity in code. */
const dictionary = {
  "en": {
    "groups": {
      "teamManagement": "Team Management",
      "recruitment": "Recruitment",
      "talents": "Talents",
      "simulator": "Team Simulator",
      "analyticsAlias": "Analytics"
    },
    "items": {
      "teams": "Teams",
      "teamAnalytics": "Team Analytics",
      "openPositions": "Open positions",
      "talentAnalytics": "Talent Analytics",
      "talents": "Talents",
      "simulator": "Team Simulator",
      "billing": "Billing",
      "assistance": "Assistance",
      "helpCenter": "Help Center",
      "accountSettings": "Account Settings",
      "corporateSettings": "Corporate Settings",
      "logout": "Logout",
      "dashboard": "Dashboard",
      "talentPool": "Talent pool"
    }
  },
  "de": {
    "groups": {
      "teamManagement": "Team Management",
      "recruitment": "Recruiting",
      "talents": "Talente",
      "simulator": "Team Simulator",
      "analyticsAlias": "Analysen"
    },
    "items": {
      "teams": "Teams",
      "teamAnalytics": "Auswertungen",
      "openPositions": "Offene Stellen",
      "talentAnalytics": "Talent Auswertungen",
      "talents": "Talente",
      "simulator": "Team Simulator",
      "billing": "Abrechnung",
      "assistance": "Unterstützung",
      "helpCenter": "Hilfe",
      "accountSettings": "Kontoeinstellungen",
      "corporateSettings": "Unternehmenseinstellungen",
      "logout": "Abmelden",
      "dashboard": "Dashboard",
      "talentPool": "Talent Pool"
    }
  },
  "fi": {
    "groups": {
      "teamManagement": "Tiimien hallinta",
      "recruitment": "Rekrytointi",
      "talents": "Osaajat",
      "simulator": "Tiimisimulaattori",
      "analyticsAlias": "Analytiikka"
    },
    "items": {
      "teams": "Tiimit",
      "teamAnalytics": "Tiimianalytiikka",
      "openPositions": "Avoimet tehtävät",
      "talentAnalytics": "Osaaja-analytiikka",
      "talents": "Osaajat",
      "simulator": "Tiimisimulaattori",
      "billing": "Laskutus",
      "assistance": "Tuki",
      "helpCenter": "Ohjekeskus",
      "accountSettings": "Tilin asetukset",
      "corporateSettings": "Yrityksen asetukset",
      "logout": "Kirjaudu ulos",
      "dashboard": "Etusivu",
      "talentPool": "Osaajapooli"
    }
  }
};

export default dictionary;
